// Static navigation/action index for the student command palette (⌘K).
//
// These are matched client-side (instant, no network) and shown under a
// "Pages" section above the live data results. Keep routes in sync with the
// student routes in App.js and the Sidebar student menu.
//
// `keywords` are extra lowercase synonyms so a search like "settings" or
// "marks" still surfaces the right page even when it isn't in the title.

import {
  LayoutDashboard,
  BookOpen,
  GraduationCap,
  PlayCircle,
  Award,
  ClipboardList,
  ClipboardCheck,
  Code,
  Brain,
  Mic,
  Video,
  Calendar,
  MessageCircle,
  MessageSquare,
  LifeBuoy,
  Settings,
  FileText,
  ShieldCheck,
} from 'lucide-react';

export const STUDENT_ACTIONS = [
  { id: 'nav-dashboard', title: 'Dashboard', subtitle: 'Go to dashboard', url: '/s/dashboard', Icon: LayoutDashboard, keywords: ['home', 'overview'] },
  { id: 'nav-learning', title: 'My Learning', subtitle: 'Your batch courses', url: '/s/learning', Icon: BookOpen, keywords: ['courses', 'classes', 'lessons'] },
  { id: 'nav-browse', title: 'Browse Courses', subtitle: 'Course catalog', url: '/s/courses', Icon: GraduationCap, keywords: ['catalog', 'enroll', 'new course'] },
  { id: 'nav-selfpaced', title: 'Self-Paced Courses', subtitle: 'Browse self-paced', url: '/s/self-paced', Icon: PlayCircle, keywords: ['recorded', 'video courses'] },
  { id: 'nav-enrollments', title: 'My Enrollments', subtitle: 'Self-paced enrollments', url: '/s/self-paced/enrollments', Icon: BookOpen, keywords: ['my courses'] },
  { id: 'nav-certificates', title: 'Certificates', subtitle: 'Your certificates', url: '/s/self-paced/certificates', Icon: Award, keywords: ['completion', 'award'] },
  { id: 'nav-assignments', title: 'Assignments', subtitle: 'Your assignments', url: '/s/assignments', Icon: ClipboardList, keywords: ['homework', 'tasks', 'submit'] },
  { id: 'nav-assessments', title: 'Quizzes & Tests', subtitle: 'Assessments', url: '/s/assessments', Icon: ClipboardCheck, keywords: ['quiz', 'exam', 'test', 'marks'] },
  { id: 'nav-practice', title: 'Coding Practice', subtitle: 'Practice problems', url: '/s/practice', Icon: Code, keywords: ['code', 'problems', 'dsa'] },
  { id: 'nav-learn-ai', title: 'Learn with AI', subtitle: 'AI learning', url: '/s/learn-with-ai', Icon: Brain, keywords: ['ai', 'tutor'] },
  { id: 'nav-mock', title: 'Mock Interview', subtitle: 'AI mock interview', url: '/s/mock-interview/setup', Icon: Mic, keywords: ['interview', 'practice interview'] },
  { id: 'nav-interviews', title: 'My Interviews', subtitle: 'Scheduled interviews', url: '/s/interviews', Icon: Video, keywords: ['placement'] },
  { id: 'nav-compliance', title: 'Mandatory Training', subtitle: 'Compliance training', url: '/s/compliance', Icon: ShieldCheck, keywords: ['compliance', 'required'] },
  { id: 'nav-materials', title: 'Materials', subtitle: 'Course materials', url: '/s/materials', Icon: FileText, keywords: ['notes', 'ppt', 'resources', 'files'] },
  { id: 'nav-calendar', title: 'Calendar', subtitle: 'Schedule & events', url: '/s/calendar', Icon: Calendar, keywords: ['schedule', 'events'] },
  { id: 'nav-chat', title: 'Batch Chat', subtitle: 'Chat with your batch', url: '/s/chat', Icon: MessageCircle, keywords: ['message', 'discuss'] },
  { id: 'nav-feedback', title: 'Feedback', subtitle: 'Share feedback', url: '/s/feedback', Icon: MessageSquare, keywords: ['review'] },
  { id: 'nav-support', title: 'Support', subtitle: 'Help & tickets', url: '/s/support', Icon: LifeBuoy, keywords: ['help', 'ticket', 'issue'] },
  { id: 'nav-account', title: 'Account Settings', subtitle: 'Manage your account', url: '/s/account-settings', Icon: Settings, keywords: ['settings', 'profile', 'password'] },
];
